import { useNavigate } from "react-router-dom";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";

export type UserWebListItem = {
	id: string;
	first_name: string;
	last_name: string;
	email: string;
	is_active: boolean;
	cpf: string | null;
	company: { cnpj: string } | null;
};

interface Props {
	users: UserWebListItem[];
	loading: boolean;
}

export default function UsersWebList({ users, loading }: Props): JSX.Element {
	const navigate = useNavigate();

	if (loading) {
		return (
			<List dense disablePadding sx={{ width: "100%" }}>
				<ListItem disablePadding>
					<ListItemAvatar>
						<CircularProgress size={24} />
					</ListItemAvatar>
					<ListItemText primary="Carregando usuários web…" />
				</ListItem>
			</List>
		);
	}

	return (
		<List dense disablePadding sx={{ width: "100%" }}>
			{users.map((item) => (
				<ListItem
					key={item.id}
					disablePadding
					sx={{
						opacity: item.is_active ? 1 : 0.6,
						bgcolor: item.is_active ? "transparent" : "#f5f5f5",
						borderRadius: 1,
					}}
				>
					<ListItemButton onClick={() => navigate(`/user-web/${item.id}`)}>
						<ListItemAvatar>
							<Avatar>
								{item.is_active ? <AccountCircleIcon /> : <NoAccountsIcon />}
							</Avatar>
						</ListItemAvatar>
						<ListItemText
							primary={`${item.first_name} ${item.last_name}`}
							secondary={item.email}
						/>
					</ListItemButton>
				</ListItem>
			))}
		</List>
	);
}
